var AT_AjaxSearch = {

  predictive_search : function(input_element, result_wrapper, result_element){
    result_element.empty().removeClass('no-result');
    jQuery('.result-ajax-search.d-block').removeClass('d-block');

    let data = {
      query : input_element.closest('form').serialize(),
      resultEl : result_element
    }

    this.request(data);
  }

  ,request: function(data){
    let url = `${_bc_config.search_url}?${data.query}`;

    $.ajax({ type: 'GET', url: url + `&section_id=call-search`})
    .fail(function(e){
      console.log('error', e);
    })
    .done(function(e){
      let div = document.createElement('div');
      div.innerHTML = e;
      data.resultEl.html($(div).find('section').html());

      data.resultEl.find('[data-search-url]').attr('href', url)

    })
    .always(function(){
      $('.result-ajax-search').show();
      $('.searchbox').removeClass('s-loading');
    })
  }

  ,attachEvents : function( bc_search_config  ){

    var ajax_search     = this
        ,search_input_id = bc_search_config.search_input.length   > 0 ? bc_search_config.search_input   : '#bc-product-search'
        ,wrapper_id      = bc_search_config.result_wrapper.length > 0 ? bc_search_config.result_wrapper : '.result-ajax-search'
        ,result_id       = bc_search_config.result_element.length > 0 ? bc_search_config.result_element : '.search-results' ;


    $(document)
    .on('keyup',search_input_id, AT_Main.debounceTime(function(e){
      var $this = $(this)
      ,_keyword       = $this.val()
      ,search_element = $this
      ,frmParent      = $(search_input_id).parents('form').first()
      ,result_wrapper = frmParent.nextAll(wrapper_id)
      ,result_element = result_wrapper.children( result_id );

      jQuery('.searchbox').removeClass("s-loading");

      if( _keyword.length < 1 ){
        result_element.empty();
        result_wrapper.hide();
      }
      else if( _keyword.length >= 2 ){
        $this.removeClass('error warning valid').addClass('valid');
        $('.searchbox').addClass('s-loading');
        !jQuery(search_input_id).hasClass('snize-input-style') && ajax_search.predictive_search( search_element ,result_wrapper, result_element );
      }else{
        $this.removeClass('error warning valid').addClass('error');
        result_element.html('<li class="result-item"><p>You must enter at least 2 characters.</p></li>').addClass('no-result');
        result_wrapper.show();
      }
    },500))

    .on('blur', '.navbar-form.search', AT_Main.debounceTime(function(e){
      var _search_block = jQuery(this);
      $('.result-ajax-search').hide();
      $('body').removeClass('search-is-typing');
    },500))

    .on('focus','.header-desktop #bc-product-search',function(){
      jQuery(this).parents('.searchbox').addClass('is-focus');
    })

    .on('blur','.header-desktop #bc-product-search',function(){
      jQuery(this).parents('.searchbox').removeClass('is-focus');
    })

    .on('click','.result-ajax-search li',e=>{
      $(e.currentTarget).closest('.result-ajax-search').addClass('d-block');
    });
  }

  ,init : function( bc_search_config ){
    this.attachEvents( bc_search_config );
  }
}

jQuery(document).ready(function($) {
  AT_AjaxSearch.init({
    "search_input"      :   "#bc-product-search"
    ,"result_wrapper"   :   ".result-ajax-search"
    ,"result_element"   :   ".search-results"
    ,"strictly_mode"    :   0
  });
})